function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import find from 'lodash/find';
import Carousel from '../carousel/Carousel';
import ElementsMobile from './ElementsMobile';
import ElementsSubTopics from './ElementsSubTopics';

var ElementsSubjectsTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(ElementsSubjectsTabs, _React$Component);

  var _super = _createSuper(ElementsSubjectsTabs);

  function ElementsSubjectsTabs() {
    var _this;

    _classCallCheck(this, ElementsSubjectsTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getUrl", function (encodedSubjectTitle, encodedTopicTitle) {
      if (encodedTopicTitle) {
        return encodedTopicTitle === 'topics-all' ? "/teaching-resources/hub/elements/".concat(encodedSubjectTitle) : "/teaching-resources/hub/elements/".concat(encodedSubjectTitle, "/").concat(encodedTopicTitle);
      }

      return encodedSubjectTitle === 'elements-home' ? '/teaching-resources/hub/elements' : "/teaching-resources/hub/elements/".concat(encodedSubjectTitle);
    });

    _defineProperty(_assertThisInitialized(_this), "getEncodedTitle", function (title) {
      if (title === 'Home' || !title) return 'elements-home';
      if (title === 'All') return 'topics-all';
      return title.toLowerCase().replace(/ /g, '-').replace(/&/g, 'and').replace(/[^a-z0-9-]/g, '');
    });

    _defineProperty(_assertThisInitialized(_this), "getTopicItems", function (elementsSubjects, topics) {
      var topicTitles = topics.sort(function (a, b) {
        return a.displayOrder > b.displayOrder;
      }).map(function (_ref) {
        var title = _ref.title;
        return title;
      });

      var uniqueTitles = _toConsumableArray(new Set(topicTitles));

      return uniqueTitles.map(function (topicTitle) {
        return _this.createTopicItem(elementsSubjects, topicTitle);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createTopicItem", function (elementsSubjects, topicTitle) {
      var _this$props = _this.props,
          activeSubject = _this$props.activeSubject,
          activeTopicTitle = _this$props.activeTopicTitle;

      var _find = find(elementsSubjects, function (_ref2) {
        var name = _ref2.name;
        return includes(name, activeSubject);
      }),
          subjectTitle = _find.title;

      var encodedSubjectTitle = _this.getEncodedTitle(subjectTitle);

      var encodedTopicTitle = _this.getEncodedTitle(topicTitle);

      return /*#__PURE__*/React.createElement("li", {
        key: topicTitle,
        className: "nav-bar__item"
      }, /*#__PURE__*/React.createElement("a", {
        className: encodedTopicTitle === activeTopicTitle ? 'nav-bar__link nav-bar__link--active' : 'nav-bar__link',
        href: _this.createUrl(encodedSubjectTitle, encodedTopicTitle),
        "data-mz": !!_this.props.mz,
        "data-module": _this.props.mz,
        "data-id": "elements-banner-tab-navigation"
      }, topicTitle));
    });

    _defineProperty(_assertThisInitialized(_this), "createSubjectItem", function (title) {
      var encodedTitle = _this.getEncodedTitle(title);

      return /*#__PURE__*/React.createElement("li", {
        key: title,
        className: "nav-bar__item"
      }, /*#__PURE__*/React.createElement("a", {
        className: encodedTitle === _this.props.activeSubject ? 'nav-bar__link nav-bar__link--active' : 'nav-bar__link',
        href: _this.createUrl(encodedTitle),
        "data-mz": !!_this.props.mz,
        "data-module": _this.props.mz,
        "data-id": "elements-banner-tab-navigation"
      }, title));
    });

    _defineProperty(_assertThisInitialized(_this), "createUrl", function (encodedSubjectTitle, encodedTopicTitle) {
      var url = _this.getUrl(encodedSubjectTitle, encodedTopicTitle);

      if (_this.props.country && _this.props.country.toLowerCase() !== 'gb') {
        url = "/en-".concat(_this.props.country.toLowerCase()).concat(url);
      }

      if (_this.props.stage) {
        url += "?stage=".concat(_this.props.stage);
      }

      return url;
    });

    return _this;
  }

  _createClass(ElementsSubjectsTabs, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          hideSubTopics = _this$props2.hideSubTopics,
          hideMobile = _this$props2.hideMobile,
          topics = _this$props2.topics,
          allTopics = _this$props2.allTopics,
          activeSubject = _this$props2.activeSubject,
          activeTopicTitle = _this$props2.activeTopicTitle,
          allSubTopics = _this$props2.allSubTopics,
          subTopics = _this$props2.subTopics,
          activeSubTopics = _this$props2.activeSubTopics,
          resourceTypes = _this$props2.resourceTypes,
          ageGroups = _this$props2.ageGroups,
          activeTypesOfResource = _this$props2.activeTypesOfResource,
          activeStages = _this$props2.activeStages;
      var validSubjects = ['Phonics', 'Spag', 'Number', 'Literacy', 'Comprehension', 'History', 'PSHE', 'Topical'];
      var elementsSubjects = this.props.elementsSubjects.filter(function (_ref3) {
        var title = _ref3.title;
        return includes(validSubjects, title);
      });
      if (!elementsSubjects || !elementsSubjects.length) return null;

      var subjectList = _toConsumableArray(new Set(elementsSubjects.sort(function (a, b) {
        return !a.displayOrder || a.displayOrder > b.displayOrder ? 1 : -1;
      }).map(function (subject) {
        return subject.title;
      }))).map(this.createSubjectItem);

      return /*#__PURE__*/React.createElement("div", {
        className: "elements"
      }, !hideMobile && /*#__PURE__*/React.createElement(ElementsMobile, {
        elementsSubjects: elementsSubjects,
        topics: allTopics,
        allSubTopics: allSubTopics,
        resourceTypes: resourceTypes,
        ageGroups: ageGroups,
        activeSubTopics: activeSubTopics,
        activeTypesOfResource: activeTypesOfResource,
        activeStages: activeStages,
        activeTopicTitle: activeTopicTitle
      }), /*#__PURE__*/React.createElement("section", {
        className: "open-nav-bar hidden-xs"
      }, /*#__PURE__*/React.createElement("div", {
        className: "nav-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "nav-bar__container"
      }, /*#__PURE__*/React.createElement(Carousel, null, this.createSubjectItem('Home'), subjectList)), !!topics && topics.length > 0 && activeSubject !== 'elements-home' && /*#__PURE__*/React.createElement("div", {
        className: "nav-bar__container nav-bar__container--secondary"
      }, /*#__PURE__*/React.createElement(Carousel, null, this.createTopicItem(elementsSubjects, 'All'), this.getTopicItems(elementsSubjects, topics)))), !hideSubTopics && !!activeTopicTitle && activeTopicTitle !== 'topics-all' && /*#__PURE__*/React.createElement(ElementsSubTopics, {
        subTopics: subTopics,
        activeSubTopics: activeSubTopics
      })));
    }
  }]);

  return ElementsSubjectsTabs;
}(React.Component);

ElementsSubjectsTabs.displayName = "ElementsSubjectsTabs";
ElementsSubjectsTabs.propTypes = {
  elementsSubjects: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeSubject: PropTypes.string,
  country: PropTypes.string,
  mz: PropTypes.string,
  stage: PropTypes.string,
  allTopics: PropTypes.array,
  topics: PropTypes.array,
  activeTopicTitle: PropTypes.string,
  allSubTopics: PropTypes.array,
  subTopics: PropTypes.array,
  activeSubTopics: PropTypes.array,
  hideSubTopics: PropTypes.bool,
  hideMobile: PropTypes.bool,
  resourceTypes: PropTypes.arrayOf(PropTypes.object),
  ageGroups: PropTypes.arrayOf(PropTypes.object),
  activeTypesOfResource: PropTypes.string,
  activeStages: PropTypes.arrayOf(PropTypes.object)
};
ElementsSubjectsTabs.defaultProps = {
  activeSubject: 'elements-home',
  resourceTypes: [],
  ageGroups: [],
  hideSubTopics: false,
  hideMobile: false
};
export default ElementsSubjectsTabs;